if ( typeof EnrollmentForm !== 'function' ) {

	class EnrollmentForm extends HTMLElement {

		constructor(){
			super();

      this.modal = this.closest('[data-enrollment-locator-modal]');
      this.modalContent = this.modal.querySelector('[data-enrollment-locator-modal-content]');
      this.inputs = this.querySelectorAll('[data-enrollment-form-input]');
      this.error = this.querySelector('[data-enrollment-form-error]');
      this.submit = this.querySelector('[data-enrollment-form-submit]');
      this.termsCheckbox = this.querySelector('#terms');
      this.referralSelect = this.querySelector('[data-enrollment-referral-select]');
      this.referralOtherWrap = this.querySelector('[data-enrollment-referral-other-wrap]');
      this.referralOtherInput = this.querySelector('[data-enrollment-referral-other-input]');
      this.departmentSelect = this.querySelector('[data-enrollment-department-select]');
      this.citySelect = this.querySelector('[data-enrollment-city-select]');
      this.areaCodeEl = this.querySelector('[data-enrollment-form-area-code]');
      this.areaCodeAttr = this.areaCodeEl.getAttribute('data-enrollment-form-area-code');
      this.areaCode = (this.areaCodeAttr && this.areaCodeAttr !== '') ? this.areaCodeAttr : '+57';

      this.init();
		}

    init() {
      this.submit.addEventListener('click', this.onEnrollmentFormSubmit.bind(this));
      this.bindInputSanitizers();
      this.bindReferralSource();
      this.bindDepartmentCity();
      this.observeModalState();
    }

    async onEnrollmentFormSubmit() {
      const isValid = this.validateEnrollmentForm();
      if (!isValid) {
        const message = this.getValidationErrorMessage();
        this.showValidationError(message);
        return;
      }

      const formData = {};
      
      // Process all inputs
      Array.from(this.inputs).forEach((curr) => {
        let value = curr.value;
        let type = curr.getAttribute('data-enrollment-form-input');
        let name = curr.getAttribute("name");
        
        // Registration type: use data-registration-value (AS/DS) instead of displayed value
        if (type === 'registrationType') {
          const registrationValue = curr.getAttribute('data-registration-value');
          formData[name] = registrationValue || value;
          return;
        }
        
        // Skip referralOther input if not visible/required
        if (type === 'referralOther') {
          if (!this.referralOtherInput.required || this.referralOtherWrap.classList.contains('is-hidden')) {
            return; // Skip this field
          }
          // Only include referral_source_other if referral_source is "Otros"
          const referralSourceValue = this.referralSelect ? this.referralSelect.value : '';
          if (referralSourceValue === 'Otros' && value && value.trim()) {
            formData[name] = value.trim();
          }
          return;
        }
        
        // Phone: send only numbers without area code
        if (type === 'phone') {
          formData[name] = value; // Already just numbers from sanitization
          return;
        }
        
        // Handle referral source
        if (type === 'referralSource') {
          formData[name] = value;
          return;
        }
        
        // All other fields
        formData[name] = value;
      });

      this.submit.setAttribute('disabled', 'disabled');
      this.submit.classList.add('loading');

      try {
        this.customer = await window.backend.createEnrollmentCustomer(formData);
        
        this.submit.classList.remove('loading');
        this.submit.classList.add('has-success');

        setTimeout(async () => {
          this.submit.removeAttribute('disabled');
          this.submit.classList.remove('has-success');

          this.renderState('default-form', 'post-form');
        }, 1500);
      } catch (e) {
        this.showError(e); 

        this.submit.removeAttribute('disabled');
        this.submit.classList.remove('loading');

        console.error(e);
      }
    }

    validateEnrollmentForm() {
      let valid = true;

      Array.from(this.inputs).forEach((input) => {
        // Validate select elements
        if (input.tagName === 'SELECT') {
          if (!input.value || input.value === '') {
            valid = false;
            input.focus();
            return;
          }
        }
        // Validate regular inputs (not checkbox)
        else if (input.type !== "checkbox" && !input.checkValidity()) {
          valid = false;
        }
      });

      // Validate "Otros" input if it's required
      if (this.referralOtherInput && this.referralOtherInput.required && !this.referralOtherInput.value.trim()) {
        valid = false;
        this.referralOtherInput.focus();
      }

      if (this.termsCheckbox && !this.termsCheckbox.checked) {
        this.termsCheckbox.focus();
        return false;
      }

      return valid;
    }

    getValidationErrorMessage() {
      const strings = window.theme?.strings?.enrollment || {};
      // Check for invalid format first (field has value but wrong format)
      for (const input of this.inputs) {
        if (input.type === 'checkbox') continue;
        if (input.tagName === 'SELECT') continue;
        const type = input.getAttribute('data-enrollment-form-input');
        const hasValue = input.value && input.value.trim() !== '';
        if (hasValue && !input.checkValidity()) {
          if (type === 'email') return strings.invalidEmailError || 'Correo inválido';
          if (type === 'phone') return strings.invalidPhoneError || 'Ingresa un número telefónico válido';
        }
      }
      // Check "Otros" field if required and empty
      if (this.referralOtherInput && this.referralOtherInput.required && !this.referralOtherInput.value.trim()) {
        return strings.missingFieldsError || 'Por favor completa todos los campos';
      }
      return strings.missingFieldsError || 'Por favor completa todos los campos';
    }

    showValidationError(message) {
      this.error.textContent = message;
      this.classList.add("has-error");
    }
  
    showError(error) {
      let errorMessage = "";
      
      // Try to parse error message as JSON first
      try {
        const data = JSON.parse(error.message);
        if (data && data.error) {
          errorMessage = data.error;
        } else if (data && data.message) {
          errorMessage = data.message;
        } else if (typeof data === 'string') {
          errorMessage = data;
        }
      } catch {
        // If not JSON, use the error message directly
        errorMessage = error.message || error.toString();
      }

      // If we have a message from the backend, show it directly
      // Otherwise fall back to general error
      this.error.textContent = errorMessage || theme.strings.enrollment.generalError;
      this.classList.add("has-error");
    }

    renderState(prev, curr) {
      this.modalContent.classList.remove(prev);
      this.modalContent.classList.add(curr);
      this.modalContent.setAttribute('data-enrollment-locator-modal-content', curr);
    }

    bindInputSanitizers() {
      const lettersOnly = /[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]/g;
      const alphanumeric = /[^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ\s]/g;
      const numbersOnly = /[^\d]/g;

      this.inputs.forEach((input) => {
        const type = input.getAttribute('data-enrollment-form-input');
        if (type === 'firstName' || type === 'lastName') {
          input.addEventListener('input', () => {
            input.value = input.value.replace(lettersOnly, '');
          });
        }

        if (type === 'referralOther') {
          input.addEventListener('input', () => {
            input.value = input.value.replace(alphanumeric, '');
          });
        }

        if (type === 'phone' || type === 'zip') {
          input.addEventListener('input', () => {
            input.value = input.value.replace(numbersOnly, '');
          });
        }
      });
    }

    bindReferralSource() {
      if (!this.referralSelect || !this.referralOtherWrap || !this.referralOtherInput) return;

      this.referralSelect.addEventListener('change', this.onReferralSourceChange.bind(this));
      this.onReferralSourceChange();
    }

    onReferralSourceChange() {
      const otherValue = this.referralSelect.dataset.enrollmentReferralOtherValue;
      const isOther = this.referralSelect.value === otherValue;

      this.referralOtherWrap.classList.toggle('is-hidden', !isOther);
      this.referralOtherInput.required = isOther;
      if (!isOther) {
        this.referralOtherInput.value = '';
      }
    }

    // Colombia: department -> city
    bindDepartmentCity() {
      if (
        !this.departmentSelect ||
        !this.citySelect ||
        !window.COLOMBIA_DEPARTMENTS_DATA ||
        !Array.isArray(window.COLOMBIA_DEPARTMENTS_DATA.departments)
      ) {
        return;
      }

      const departments = window.COLOMBIA_DEPARTMENTS_DATA.departments;
      this.departmentSelect.innerHTML = '';
      const departmentPlaceholderText = this.departmentSelect.getAttribute('data-enrollment-placeholder') || 'Departamento';

      const departmentPlaceholder = document.createElement('option');
      departmentPlaceholder.value = '';
      departmentPlaceholder.textContent = departmentPlaceholderText;
      departmentPlaceholder.disabled = true;
      departmentPlaceholder.selected = true;
      this.departmentSelect.appendChild(departmentPlaceholder);

      departments.forEach((department) => {
        if (!department || !department.name) return;
        const opt = document.createElement('option');
        opt.value = department.name;
        opt.textContent = department.name;
        this.departmentSelect.appendChild(opt);
      });

      this.departmentSelect.addEventListener('change', this.onDepartmentChange.bind(this));
    }

    // Colombia: load cities based on selected department
    onDepartmentChange() {
      if (
        !this.departmentSelect ||
        !this.citySelect ||
        !window.COLOMBIA_DEPARTMENTS_DATA ||
        !Array.isArray(window.COLOMBIA_DEPARTMENTS_DATA.departments)
      ) {
        return;
      }

      const selectedDepartment = this.departmentSelect.value;
      const departmentData = window.COLOMBIA_DEPARTMENTS_DATA.departmentsByName?.[selectedDepartment]
        || window.COLOMBIA_DEPARTMENTS_DATA.departments.find((department) => department.name === selectedDepartment);
      const cities = (departmentData?.cities || []).map((city) => city.name).filter(Boolean);

      this.citySelect.innerHTML = '';
      const cityPlaceholderText = this.citySelect.getAttribute('data-enrollment-placeholder') || 'Ciudad';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = cityPlaceholderText;
      placeholder.disabled = true;
      placeholder.selected = true;
      this.citySelect.appendChild(placeholder);

      cities.forEach((city) => {
        const opt = document.createElement('option');
        opt.value = city;
        opt.textContent = city;
        this.citySelect.appendChild(opt);
      });
    }

    observeModalState() {
      if (!this.modal) return;

      this.modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'aria-hidden' && this.modal.getAttribute('aria-hidden') === 'true') {
            this.resetForm();
          }
        });
      });

      this.modalObserver.observe(this.modal, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    resetForm() {
      this.inputs.forEach((input) => {
        if (input.type === 'checkbox') {
          input.checked = false;
          return;
        }

        if (input.tagName === 'SELECT') {
          if (input === this.departmentSelect) {
            input.selectedIndex = 0;
            // Reset city select and keep only placeholder
            if (this.citySelect) {
              this.citySelect.innerHTML = '';
              const cityPlaceholderText = this.citySelect.getAttribute('data-enrollment-placeholder') || 'Ciudad';
              const placeholder = document.createElement('option');
              placeholder.value = '';
              placeholder.textContent = cityPlaceholderText;
              placeholder.disabled = true;
              placeholder.selected = true;
              this.citySelect.appendChild(placeholder);
            }
          } else if (input === this.referralSelect) {
            input.selectedIndex = 0;
            this.onReferralSourceChange();
          } else {
            input.selectedIndex = 0;
          }
          return;
        }

        // Skip readonly fields (like registration_type)
        if (!input.hasAttribute('readonly')) {
          input.value = '';
        }
      });

      if (this.referralOtherWrap) {
        this.referralOtherWrap.classList.add('is-hidden');
      }
      if (this.referralOtherInput) {
        this.referralOtherInput.required = false;
        this.referralOtherInput.value = '';
      }

      this.error.textContent = '';
      this.classList.remove('has-error');
      this.submit.classList.remove('loading', 'has-success');
      this.submit.removeAttribute('disabled');
      
      // Reset modal content state
      if (this.modalContent) {
        this.modalContent.classList.remove('post-form');
        this.modalContent.classList.add('default-form');
        this.modalContent.setAttribute('data-enrollment-locator-modal-content', 'default-form');
      }
    }
	}

  if ( typeof customElements.get('enrollment-form') == 'undefined' ) {
    customElements.define('enrollment-form', EnrollmentForm);
	}

}